/**
 * =================
 * SITE SUBNAV
 * navigation
 * =================
 */
app.subnav = (function(module) {

	// staff
	var $nav;

	module.init = function() {
		$nav = app.$('.navigation-site');

		if (!$nav.length) return;

		_setNav();
		_bindingNavEvents();
	};

	// fn's
	function _setNav() {
		$nav.find('li').has('.lnk[href^="'+ window.location.hash +'"]').addClass('active');
	}

	function _bindingNavEvents() {
		$nav.find('li').has('.lnk[href^="#site-submenu"]')
			.on('click', '.lnk[href^="#site-submenu"]', function(e) {
				e.preventDefault();
			})
			.on('mouseenter', _activate)
			.on('mouseleave', _deactivate);
	}

	// auxiliary
	function _activate() {
		var $item = app.$(this);

		if (!$item.is('.active')) {
            $item.addClass('active');
        }
	}

	function _deactivate() {
		var $item = app.$(this);

		if ($item.is('.active')) {
			$item.find(".site-submenu").fadeOut();
			$item.removeClass('active');
		}
	}

	// kickstart!
	app.$(function() {
		module.init();
	});

	return module;

}(app.subnav || {}));


/* EOF */
